var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.8946,
    y1: 514.048,
    x2: 255.8946,
    y2: 2.2251,
    gradientTransform: "matrix(1.0003 0 0 -1.0003 0.0169 514.2258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0bb1d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M255.999,512l-8.134-3.619c-2.089-0.929-51.745-23.261-101.892-66.086 c-29.823-25.469-53.675-52.976-70.888-81.757c-22.004-36.789-33.159-75.662-33.159-115.539V124.29 c0-29.095,20.85-53.95,49.576-59.097c48.502-8.692,93.168-35.18,115.476-50.195C221.552,5.186,238.503,0,255.999,0 s34.447,5.186,49.022,14.996c22.308,15.015,66.974,41.503,115.477,50.195l0,0c28.726,5.148,49.576,30.002,49.576,59.097v120.71 c0,39.877-11.157,78.749-33.159,115.539c-17.214,28.781-41.064,56.288-70.888,81.757c-50.147,42.825-99.803,65.157-101.892,66.086 L255.999,512z M255.999,40.014c-9.505,0-18.731,2.828-26.678,8.177c-24.919,16.773-75.043,46.402-130.761,56.387 c-9.63,1.726-16.621,10.015-16.621,19.711v120.71c0,126.33,138.66,204.879,174.061,222.866 c15.401-7.819,50.359-27.084,84.791-56.643c59.233-50.85,89.267-106.775,89.267-166.224V124.29c0-9.695-6.99-17.985-16.621-19.711 l0,0c-55.718-9.985-105.843-39.616-130.761-56.387C274.729,42.842,265.504,40.014,255.999,40.014z M383.969,176.305l-29.864-26.632 L225.014,294.431l-68.381-64.018l-27.347,29.21l98.307,92.036L383.969,176.305z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7b6aa2e09a8ddd5002710380d085d42e.svg";
export { ForwardRef as ReactComponent };